import { message } from "antd";

import { useEffect, useState } from "react";
import AddMemberPopup from "../common/AddMember";

export default function OrganizationTab() {
  const [data, setData] = useState([]);
  var userId = localStorage.getItem("UserId");
  const token = localStorage.getItem("token");
  const [isOpen, setIsOpen] = useState(false);
  

  const getData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ROOT}/api/auth/memberslist/?OrganizationId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.message != "No members yet") {
          setData(data.message);
        } else {
          setData([]);
        }
      } else {
        console.log("Error:", response.status);
      }
    } catch (error) {
      console.log("Error:", error.message);
    }
  };

  useEffect(() => {
    getData();
  }, [isOpen]);

  const id = localStorage.getItem("UserId");

  const deleteMember = (Id) => {
    fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/memberslist/?Id=${Id}`, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(async (response) => {
        if (response.ok) {
          message.success("Member has been deleted!");
          setData((prev) => prev.filter((member) => member.Id !== Id));
        } else {
          const error = await response.json();
          message.error(error?.message || "Failed to delete member.");
        }
      })
      .catch(() => {
        message.error("Something went wrong. Please try again.");
      });
  };

  

  const handleAddMember = async (values) => {
    if (values?.MemberId) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/super-admin/assign-apps/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify(values),
        });
  
        const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || "Request failed");
        }
  
        setIsOpen(false);
        message.success("Member added successfully!");
      } catch (error) {
        message.error("Failed to add member");
        console.error("API Error:", error);
      }
    } else {
      const body = {
        isOrganizer: false,
        OrganizationId: id,
        first_name: values?.firstName,
        last_name: values?.lastName,
        email: values?.email,
        password: values?.password,
        modules: ["Conversational AI"],
      };
  
      try {
        const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/signup/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
          body: JSON.stringify(body),
        });
  
        const data = await response.json();
  
        if (response.ok) {
          message.success("Member added successfully!");
          setIsOpen(false);
        } else {
          message.error(data?.message || "Failed to add member.");
          console.error("Signup failed:", data);
        }
  
        return data;
      } catch (error) {
        console.error("Error adding member:", error);
        message.error("An error occurred. Please try again later.");
        return null;
      }
    }
  };
  

  
  const link = "https://app.avatare.com/register/" + id;
  return (
    <div>
      <div className="mb-6">
        <div className="flex justify-between">
        <h2 className="text-lg font-medium text-gray-900 mb-2">
          Organization Settings
        </h2>
        <button className="px-3 py-2 primary" onClick={() => setIsOpen(true)}>
          Add New Member
        </button>
        </div>
        <p className="text-sm text-gray-600">
          Below is the organization settings page. Make changes as you desire.
        </p>
      </div>

      <div className="mb-8">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Team Invite Link
        </label>
        <div className="flex">
          <input
            type="text"
            defaultValue={link}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none custom-outline focus:border-transparent"
            readOnly
          />
          <button
            onClick={() => {
              navigator.clipboard
                .writeText(link)
                .then(() => {
                  message.success("Link copied to clipboard!");
                })
                .catch(() => {
                  message.error("Failed to copy link.");
                });
            }}
            className="px-4 py-2 bg-gray-100 border border-l-0 border-gray-300 rounded-r-md hover:bg-gray-200 cursor-pointer"
          >
            <img src="/copy.svg" />
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-medium text-gray-700">
                Member
              </th>
              <th className="text-left py-3 px-4 font-medium text-gray-700">
                Credits Granted
              </th>
              <th className="text-left py-3 px-4 font-medium text-gray-700">
                Credits Used
              </th>
              <th className="text-left py-3 px-4 font-medium text-gray-700">
                Status
              </th>
              <th className="text-left py-3 px-4 font-medium text-gray-700">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.filter((member) => member.modules?.includes("Conversational AI")).map((member, index) => (
              <tr key={index} className="border-b border-gray-100">
                <td className="py-4 px-4">
                  <div>
                    <div className="font-medium text-gray-900">
                      {member.first_name + " "+ member.last_name}
                    </div>
                    <div className="text-sm text-gray-500">{member.email}</div>
                  </div>
                </td>
                <td className="py-4 px-4 text-gray-900">
                 
                    {member?.credits_assigned?.toLocaleString()}
                  
                </td>
                <td className="py-4 px-4  text-gray-900">
                  {(
                    member?.credits_assigned - member?.credits
                  )?.toLocaleString()}
                </td>
                <td className="py-4 px-4">
                  <span
                    className={`inline-flex px-2 py-1 text-xs font-medium  ${
                      member?.isVerified
                        ? "bg-green-100 text-green-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                  >
                    {member?.isVerified ? "Active" : "In Active"}
                  </span>
                </td>
                <td className="py-4 px-4">
                  <div className="flex space-x-2">
                    {/* <button className="p-1 hover:bg-gray-100 rounded">
                      <div className="w-4 h-4 bg-gray-400"></div>
                    </button>
                    <button className="p-1 hover:bg-gray-100 rounded">
                      <div className="w-4 h-4 bg-gray-400"></div>
                    </button>
                    <button className="p-1 hover:bg-gray-100 rounded">
                      <div className="w-4 h-4 bg-gray-400"></div>
                    </button> */}
                    <button
                      onClick={() => deleteMember(member?.Id)}
                      className="p-1 hover:bg-gray-100 rounded"
                    >
                      <img src="/delete-member.svg" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <AddMemberPopup
        members={data}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        handleSubmit={handleAddMember}
        handleExistingMemberSubmit={handleAddMember}
      />
    </div>
  );
}
